module.exports = __webpack_public_path__ + "img/karlsminde.25a87f2.jpg";